var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Flexbox } from '../../layout';
import NotificationsFlyout from './NotificationsFlyout';
import UserMenu from './UserMenu';
import { LoginButton, NavItem, Tooltip } from './style';
var NOTIFICATION_FLYOUT = 'NOTIFICATION_FLYOUT';
var USER_MENU_FLYOUT = 'USER_MENU_FLYOUT';
var UserSection = function (props) {
    var notifications = props.notifications;
    var _a = React.useState({
        isNotificationsFlyoutOpen: !!props.notificationsOpened,
        isUserMenuFlyoutOpen: false
    }), flyoutState = _a[0], setFlyoutState = _a[1];
    var toggleFlyout = function (flyoutName) {
        setFlyoutState({
            isNotificationsFlyoutOpen: flyoutName === NOTIFICATION_FLYOUT,
            isUserMenuFlyoutOpen: flyoutName === USER_MENU_FLYOUT
        });
    };
    return (_jsx(Flexbox, __assign({ alignItems: "center" }, { children: props.isAuthenticated ? (_jsxs(_Fragment, { children: [props.children, notifications && !props.hideNotifications && (_jsx(Tooltip, __assign({ "data-tool-tip": "Notifications" }, { children: _jsx(NotificationsFlyout, { isFlyoutOpen: flyoutState.isNotificationsFlyoutOpen, onOpenFlyout: toggleFlyout, name: NOTIFICATION_FLYOUT, notifications: notifications, copies: props.copies.notifications, markAllAsRead: props.markAllAsRead, loadMore: props.loadMoreNotifications, onClick: props.onNotificationsClick, onSingleNotificationClick: props.onSingleNotificationClick, theme: props.theme, notificationIcon: props.notificationIcon }) }))), _jsx(Tooltip, __assign({ "data-tool-tip": "Your Account" }, { children: _jsx(UserMenu, { authUserId: props.authUserId, logEvent: props.logEvent, fullName: props.fullName, pictureUrl: props.pictureUrl, pendingSubmissions: props.pendingSubmissions, newTabAll: props.userMenuNewTabAll, onMenuButtonClick: props.onMenuButtonClick, showUserFullName: props.showUserFullName, linkSettings: {
                            contentStats: {
                                hidden: props.hideContentStatistics
                            }
                        }, theme: props.theme }) }))] })) : (!props.authStatePending && (_jsx(_Fragment, { children: _jsx(NavItem, { children: _jsx(LoginButton, __assign({ onClick: props.onLogin }, { children: "Login" })) }) }))) })));
};
export default UserSection;
//# sourceMappingURL=UserSection.js.map